import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { setMode } from "./actions";
import Component, { type ActionProps, type MapProps } from "./component";
import { localStateSelector, makeHeadingSelector, makeHintSelector, makeLinkInfoSelector } from "./selectors";
import { type LoginForm } from "./types";

const makeMapStateToProps = () => {
  const headingSelector = makeHeadingSelector();
  const hintSelector = makeHintSelector();
  const linkInfoSelector = makeLinkInfoSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      heading: headingSelector(state, props),
      hint: hintSelector(state, props),
      linkInfo: linkInfoSelector(state, props),
      mode: localState.mode
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  setMode: (mode: LoginForm.Mode) => dispatch(setMode(props, mode))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
